<template>
  <div class="bm-privacy" :id="id">
    <div ref="box"
         class="bm-privacy__recall"
         @click="openCustomSettings()"
         @mouseenter="expandBox"
         @mouseleave="restoreBox">
      {{ 'bmPrivacy.settings' | translate }}
    </div>

    <div ref="quickSettings"
         v-if="quickSettingsVisible"
         class="bm-privacy__quick-settings">
      <div class="bm-privacy__header">
        <p>{{ 'bmPrivacy.agreementTitle' | translate }}</p>
        <p id="bm-privacy-consent">{{ consentText }}. <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="nofollow">{{ 'bmPrivacy.privacyPolicy' | translate }} Autopay</a></p>
      </div>

      <div class="bm-privacy__button-wrapper">
        <button type="button" @click="acceptAllAgreements()">
          {{ 'bmPrivacy.acceptAll' | translate }}
        </button>
        <button type="button" @click="openCustomSettings()">
          {{ 'bmPrivacy.customizeSelection' | translate }}
        </button>
      </div>
    </div>

    <bm-privacy-modal :visible="customSettingsVisible"
                     @close="customSettingsVisible = false">
      <div class="bm-privacy__custom-settings">
        <div class="bm-privacy__header">
          <p>{{ 'bmPrivacy.advancedSettings' | translate }}</p>
          <p>{{ 'bmPrivacy.settingsInfo' | translate }}</p>
        </div>

        <p>{{ 'bmPrivacy.userId' | translate }}: {{ settings.uuid }}</p>

        <div class="bm-privacy__choose">
          <div class="bm-privacy__choose__list">
            <a v-if="necessaryVendors" :class="{ active: activeType === 'necessary' }" @click="activeType = 'necessary'">{{ 'bmPrivacy.necessary' | translate }}</a>
            <a v-if="surveyVendors" :class="{ active: activeType === 'survey' }" @click="activeType = 'survey'">{{ 'bmPrivacy.survey' | translate }}</a>
            <a v-if="marketingVendors" :class="{ active: activeType === 'marketing' }" @click="activeType = 'marketing'">{{ 'bmPrivacy.marketing' | translate }}</a>
            <a v-if="socialVendors" :class="{ active: activeType === 'social' }" @click="activeType = 'social'">{{ 'bmPrivacy.social' | translate }}</a>
            <a v-if="advertisementVendors" :class="{ active: activeType === 'advertisement' }" @click="activeType = 'advertisement'">{{ 'bmPrivacy.advertisement' | translate }}</a>
            <a :class="{ active: activeType === 'cookie' }" @click="activeType = 'cookie'">{{ 'bmPrivacy.cookies' | translate }}</a>
            <a :class="{ active: activeType === 'admin' }" @click="activeType = 'admin'">{{ 'bmPrivacy.admin' | translate }}</a>
          </div>

          <div v-if="currentVendors" class="bm-privacy__choose__details">
            <div>
              <span>{{ 'bmPrivacy.purpose' | translate }}:</span>
              <div class="bm-privacy__control-wrapper">
                <input type="checkbox"
                       :checked="currentVendors.purpose"
                       :disabled="activeType === 'necessary'"
                       @change="setPurposeAgreement(activeType)">
                <label>{{ 'bmPrivacy.' + activeType | translate }}</label>
              </div>
            </div>

            <div>
              <span>{{ 'bmPrivacy.vendors' | translate }}:</span>
              <div>
<!--                <div class="bm-privacy__control-wrapper all">-->
<!--                  <input type="checkbox"-->
<!--                         :name="activeType + '_all'"-->
<!--                         :id="activeType + '_all'"-->
<!--                         :checked="currentVendors.all"-->
<!--                         :disabled="activeType === 'necessary'"-->
<!--                         @change="setVendorAgreement(true, !currentVendors.all, activeType)"/>-->
<!--                  <label :for="activeType + '_all'">{{ 'bmPrivacy.all' | translate }}</label>-->
<!--                </div>-->
                <div v-for="vendor in currentVendors.list" :key="vendor.id" class="bm-privacy__control-wrapper">
                  <input type="checkbox"
                         :name="'vendor_' + vendor.id"
                         :id="'vendor_' + vendor.id"
                         :checked="vendor.unblocked"
                         :disabled="vendor.type === 'necessary'"
                         @change="setVendorAgreement(vendor.id, !vendor.unblocked)"/>
                  <label :for="'vendor_' + vendor.id">{{ vendor.name }}</label>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="activeType === 'cookie'" class="bm-privacy__choose__details">
            <div v-for="(cookie, index) in cookiesSet" :key="index" class="bm-privacy__control-wrapper" style="margin-bottom: 25px;">
              <div>
                <p><span>{{ 'bmPrivacy.name' | translate }}:</span> {{ cookie.name }}</p>
                <p><span>{{ 'bmPrivacy.value' | translate }}:</span> {{ cookie.value }}</p>
                <p v-if="cookie.vendor !== 'unknown'"><span>{{ 'bmPrivacy.vendor' | translate }}:</span> {{ cookie.vendor }}</p>
                <p v-else><span>{{ 'bmPrivacy.vendor' | translate }}:</span> {{ 'bmPrivacy.' + cookie.vendor | translate }}</p>
                <p><span>{{ 'bmPrivacy.purpose' | translate }}:</span> {{ 'bmPrivacy.' + cookie.purpose | translate }}</p>
                <p><span>{{ 'bmPrivacy.validity' | translate }}:</span> {{ 'bmPrivacy.' + cookie.validity | translate }}</p>
              </div>
            </div>
          </div>

          <div v-else-if="activeType === 'admin'" class="bm-privacy__choose__details">
            <div>
              <div>
                <p>{{ 'bmPrivacy.dataAdministratorIs' | translate }}:</p>
                <p>Autopay S.A.</p>
                <p>ul. Powstańców Warszawy 6</p>
                <p>81-718 Sopot</p>
                <p>{{ 'bmPrivacy.pl' | translate }}</p>
                <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="nofollow">{{ 'bmPrivacy.privacyPolicy' | translate }}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="bm-privacy__button-wrapper">
          <button type="button" @click="saveSettings">{{ 'bmPrivacy.saveAndClose' | translate }}</button>
        </div>

        <div v-if="settings.updatedAt" class="bm-privacy__choice">
          {{ 'bmPrivacy.updatedAt' | translate }}: {{ settings.updatedAt | date }}
        </div>
      </div>
    </bm-privacy-modal>
  </div>
</template>

<script type="text/javascript">
import BmPrivacyModal from './partial/Modal'
import { VENDOR_TYPES } from '../constants/vendor-types.const'
import { setSettingsInStorage, getSettingsFromStorage } from '../functions/storage-functions'
import {
  getDefaultBmPrivacyObject,
  recognizeVendorsFromCookies,
  checkBlockedArrayWithSettings,
  setVendorAgreementInSettings,
  setPurposeAgreementInSettings,
  getNecessaryVendorsFromSettings,
  getSurveyVendorsFromSettings,
  getMarketingVendorsFromSettings,
  getSocialVendorsFromSettings,
  getAdvertisementVendorsFromSettings,
  getCookiesData
} from '../functions/manager-functions'

export default {
  name: 'BmPrivacyComponent',
  components: {
    BmPrivacyModal
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    quickSettingsVisible: false,
    customSettingsVisible: false,
    settings: {},
    activeType: null
  }),
  created () {
    if (!window.bluemedia || !window.bluemedia.privacy || !window.bluemedia.privacy.version || !window.bluemedia.privacy.consent) {
      window.bluemedia = { privacy: getDefaultBmPrivacyObject() }
    }
    this.settings = Object.assign({}, getSettingsFromStorage())
    if (!this.settings.updatedAt || this.settings.version !== window.bluemedia.privacy.version) {
      this.quickSettingsVisible = true
    }
    recognizeVendorsFromCookies(this.settings)
    checkBlockedArrayWithSettings(window.bluemedia.privacy.blockedElements, this.settings)
    window.addEventListener('BmPrivacy:add', () => {
      checkBlockedArrayWithSettings(window.bluemedia.privacy.blockedElements, this.settings)
    })
  },
  computed: {
    language: function () {
      return this.$i18n.locale()
    },
    consentText: function () {
      return window.bluemedia.privacy.consent[this.language]
    },
    necessaryVendors: function () {
      return getNecessaryVendorsFromSettings(this.settings)
    },
    surveyVendors: function () {
      return getSurveyVendorsFromSettings(this.settings)
    },
    marketingVendors: function () {
      return getMarketingVendorsFromSettings(this.settings)
    },
    socialVendors: function () {
      return getSocialVendorsFromSettings(this.settings)
    },
    advertisementVendors: function () {
      return getAdvertisementVendorsFromSettings(this.settings)
    },
    cookiesSet: function () {
      return getCookiesData()
    },
    currentVendors: function () {
      if (this.activeType === VENDOR_TYPES.necessary) {
        return this.necessaryVendors
      }
      if (this.activeType === VENDOR_TYPES.survey) {
        return this.surveyVendors
      }
      if (this.activeType === VENDOR_TYPES.marketing) {
        return this.marketingVendors
      }
      if (this.activeType === VENDOR_TYPES.social) {
        return this.socialVendors
      }
      if (this.activeType === VENDOR_TYPES.advertisement) {
        return this.advertisementVendors
      }
      return null
    }
  },
  methods: {
    expandBox () {
      this.$refs.box.style.width = this.$refs.box.scrollWidth + 10 + 'px'
    },
    restoreBox () {
      this.$refs.box.style.width = null
    },
    changeLanguage (language) {
      this.$i18n.set(language)
    },
    openCustomSettings () {
      this.customSettingsVisible = true
      if (this.necessaryVendors) {
        this.activeType = VENDOR_TYPES.necessary
        return
      }
      if (this.surveyVendors) {
        this.activeType = VENDOR_TYPES.survey
        return
      }
      if (this.marketingVendors) {
        this.activeType = VENDOR_TYPES.marketing
        return
      }
      if (this.socialVendors) {
        this.activeType = VENDOR_TYPES.social
      }
    },
    setPurposeAgreement (purposeType, newPurposeValue) {
      setPurposeAgreementInSettings(purposeType, newPurposeValue, this.settings)
    },
    setVendorAgreement (vendorId, newVendorValue, vendorType) {
      setVendorAgreementInSettings(vendorId, newVendorValue, vendorType, this.settings)
    },
    acceptAllAgreements () {
      Object.keys(VENDOR_TYPES).forEach(type => {
        this.setPurposeAgreement(VENDOR_TYPES[type], true)
      })
      this.saveSettings()
    },
    saveSettings () {
      setSettingsInStorage(this.settings, this.$bmPrivacyConfig, this.$i18n.locale())
        .then((result) => {
          this.quickSettingsVisible = false
          this.customSettingsVisible = false
          if (result) {
            checkBlockedArrayWithSettings(window.bluemedia.privacy.blockedElements, this.settings)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" src="../styles/styles.scss"></style>
